<template>
    <div class="table-responsive">
        <base-crud
            ref="baseCrud"
            v-if="loaded"
            crudName="Reserva de Veículo"
            newText="Nova Reserva"
            :table="table"
            :columns="columns"
            :options="options"
            :endPoint="endPoint"
            :enableAdd="true"
            :enableEdit="false"
            :enableDelete="false"
            :enableView="true"
            :dataForm="dataForm"
            :customFilters="customFilters"
            @filteredRetreat="filteredRetreat"
            @filteredDevolution="filteredDevolution"
            :extra="extra"
            @editing="editing"
            @finish="finish"
            @cancel="cancel"
        ></base-crud>

        <!-- Modal de Finalização de Reserva -->
        <base-modal
            :isVisible="showFinishModal"
            title="Finalizar Reserva"
            size="md"
            @close="closeFinishModal"
        >
            <template #content>
                <form @submit.prevent="confirmFinish">
                    <div class="form-group">
                        <label for="km_inicial">KM Inicial:</label>
                        <input
                            type="number"
                            id="km_inicial"
                            class="form-control"
                            v-model="finishForm.km_inicial"
                        />
                    </div>
                    <div class="form-group">
                        <label for="km_final">KM Final: <span class="text-danger">*</span></label>
                        <input
                            type="number"
                            id="km_final"
                            class="form-control"
                            v-model="finishForm.km_final"
                            :min="finishForm.km_inicial"
                            placeholder="Informe o KM final"
                            required
                        />
                    </div>
                    <div v-if="finishForm.km_inicial && finishForm.km_final" class="form-group">
                        <label>KM Percorrido:</label>
                        <input
                            type="text"
                            class="form-control"
                            :value="finishForm.km_final - finishForm.km_inicial"
                            readonly
                            disabled
                        />
                    </div>
                </form>
            </template>
            <template #actions>
                <button
                    type="button"
                    class="btn btn-secondary"
                    @click="closeFinishModal"
                >
                    Cancelar
                </button>
                <button
                    type="button"
                    class="btn btn-primary btn-sm"
                    @click="confirmFinish"
                    :disabled="!finishForm.km_final || finishForm.km_final < finishForm.km_inicial"
                >
                    Finalizar Reserva
                </button>
            </template>
        </base-modal>
    </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";
import BaseModal from "../Base/BaseModal";
import {getMessage} from "../../composables/message";
import {shouldHideVehicleData, createVehicleTemplate} from "../../composables/useVehicleVisibility";

export default {
    data: function () {
        return {
            customFilters: [
                {
                    name: "retreat_date",
                    type: "calendar",
                    call: "filteredRetreat",
                },
                {
                    name: "devolution_date",
                    type: "calendar",
                    call: "filteredDevolution",
                },
            ],

            loaded: true,
            retreat_date: "",
            devolution_date: "",

            // Modal de finalização
            showFinishModal: false,
            currentReserveToFinish: null,
            finishForm: {
                km_inicial: 0,
                km_final: null
            },

            // Controle de tempo para reatividade
            currentTime: new Date(),
            timeUpdateInterval: null,

            table: "reserve_vehiclesTable",
            // pages: [],
            // url: '',
            columns: [
                "id",
                "user_id",
                "vehicle_id",
                "vehicle_board",
                "cost_center_id",
                "retreat_date",
                "devolution_date",
                "reserve_status",
                "city_destination",
                "actions",
            ],
            tableData: [
                "id",
                "user_id",
                "vehicle_id",
                "vehicle_board",
                "retreat_date",
                "devolution_date",
                "reserve_status",
            ],
            options: {
                sortable: [
                    "id",
                    "user_id",
                    "vehicle_id",
                    "vehicle_board",
                    "cost_center_id",
                    "retreat_date",
                    "devolution_date",
                    "reserve_status",
                ],
                columns: [
                    "id",
                    "user_id",
                    "vehicle_id",
                    "vehicle_board",
                    "cost_center_id",
                    "retreat_date",
                    "devolution_date",
                    "reserve_status",
                    "actions",
                ],
                filterByColumn: true,
                debounce: 1000,
                filterable: [
                    "id",
                    "user_id",
                    "vehicle_id",
                    "vehicle_board",
                    "branch_id",
                    "cost_center_id",
                    "reserve_status",
                    "city_destination"
                ],
                pagination: {chunk: 10, dropdown: false, nav: "scroll"},
                perPage: 10,
                perPageValues: [10, 25, 50, 100],
                headings: {
                    id: "ID",
                    user_id: "Nome do Usuário",
                    vehicle_id: "Veículo",
                    vehicle_board: "Placa Veículo",
                    cost_center_id: "Centro de Custos do Veículo",
                    retreat_date: "Data de Retirada",
                    devolution_date: "Data de Devolução",
                    reserve_status: "Status da Reserva",
                    city_destination: 'Cidade Destino',
                    actions: "Ações",
                },

                texts: {
                    filterBy: "Filtrar",
                    defaultOption: "Selecione",
                },
                listColumns: {
                    reserve_status: [
                        {
                            id: 1,
                            text: "Pré-reserva",
                        },
                        {
                            id: 2,
                            text: "Reservado",
                        },
                        {
                            id: 3,
                            text: "Cancelado",
                        },
                        {
                            id: 4,
                            text: "Retirado",
                        },
                        {
                            id: 5,
                            text: "Devolvido",
                        },
                    ],
                    cost_center_id: [], // Será populado dinamicamente
                },
                templates: {
                    user_id: function (h, row, index) {
                        return row.user ? row.user.name : "Sem Nome";
                    },
                    reserve_status: function (h, row, index) {
                        return row.reserve_statuses
                            ? row.reserve_statuses.title
                            : "Sem Nome";
                    },
                    vehicle_id: function (h, row, index) {
                        // Função será sobrescrita no mounted() / Function will be overwritten in mounted()
                        return row.user_id !== this.$store.state.user.id && this.$store.state.user.access_nivel < 3 ? 'Veículo Oculto' : row.vehicles.description;
                    },
                    vehicle_board: function (h, row, index) {
                        // Função será sobrescrita no mounted() / Function will be overwritten in mounted()
                        return row.user_id !== this.$store.state.user.id && this.$store.state.user.access_nivel < 3 ? '***-***' : row.vehicles.description;
                    },
                    cost_center_id: function (h, row, index) {
                        return row.vehicles && row.vehicles.cost_center
                            ? row.vehicles.cost_center.erp_code
                            : "Compartilhado";
                    },
                    city_destination: function (h, row, index) {
                        return row.city_destination ? row.city_destination.city_destination.description : "";
                    },
                    retreat_date: function (h, row, index) {
                        if(!row.retreat_date) return '-';

                        let [date, hour] = row.retreat_date.split(" ");
                        date = date.split('-').reverse().join('/');

                        return `${date} ${hour}`;
                    },
                },
                requestFunction: function (data) {
                    let requestData = {};

                    let query = this.$parent.$parent.query(data.query);

                    requestData.params = data;

                    if (
                        this.$parent.$parent.retreat_date != null &&
                        this.$parent.$parent.retreat_date != ""
                    ) {
                        requestData.params.retreat_date = this.$parent.$parent.retreat_date;
                    }

                    if (
                        this.$parent.$parent.devolution_date != null &&
                        this.$parent.$parent.devolution_date != ""
                    ) {
                        requestData.params.devolution_date = this.$parent.$parent.devolution_date;
                    }

                    requestData.params.query = "";
                    requestData.params.with = [
                        "user",
                        "branch",
                        "reserve_statuses",
                        "vehicles",
                        "vehicles.costCenter", // Incluindo centro de custos do veículo / Including vehicle cost center
                        "cityDestination.city_destination"
                    ];

                    return this.$http.get(this.url + "?" + query, requestData).catch(
                        function (e) {
                            this.dispatch("error", e);
                        }.bind(this)
                    );
                },
            },
            extra: [], // Será inicializado dinamicamente no mounted()
            endPoint: "myreserves/",
            dataForm: {},
        };
    },
    components: {
        BaseCrud,
        BaseModal,
    },
    methods: {
        filteredRetreat(date) {
            this.retreat_date = date;
        },
        filteredDevolution(date) { // Corrigido parâmetro / Fixed parameter
            this.devolution_date = date;
        },
        query: function (query) {
            let columns = {
                id: "id",
                user_id: "user[name]",
                retreat_date: "retreat_date",
                devolution_date: "devolution_date",
                vehicle_id: "vehicles[description]",
                vehicle_board: "vehicles[board]",
                reserve_status: "reserve_status[title]",
                city_destination: "cityDestination.city_destination[description]",
                cost_center_id: "vehicles[cost_center_id]",
            };

            let filters = "orderByDesc=retreat_date&";

            $.each(query, function (index, value) {
                filters += columns[index] + "=" + value + "&";
            });
            return filters;
        },
        editing: function (props, row, index) {
            const self = this;

            if (props.row.reserve_status == "4" || props.row.reserve_status == "5") {
                swal(
                    "Erro",
                    "Esta reserva não pode ser alterada, pois já existe check-out/check-in realizado",
                    "info"
                );
            } else if (props.row.reserve_status == "3") {
                swal(
                    "Erro",
                    "Esta reserva não pode ser alterada, pois está cancelada",
                    "info"
                );
            } else {
                const url = this.$router.resolve({
                    path: this.endPoint + "edit/" + props.row.id,
                }).href;
                window.open(url, '_blank');
            }
        },
        cancel: function (props, row, index) {
            const self = this;

            if (props.row.reserve_status == "4" || props.row.reserve_status == "5") {
                swal(
                    "Erro",
                    "Esta reserva não pode ser alterada, pois já existe check-out/check-in realizado",
                    "info"
                );
            } else if (props.row.reserve_status == "3") {
                swal(
                    "Erro",
                    "Esta reserva não pode ser alterada, pois está cancelada",
                    "info"
                );
            } else {
                self.save(props);
            }
        },

        finish: function (props, row, index) {
            if (props.row.reserve_status == "3") {
                swal(
                    "Erro",
                    "Esta reserva não pode ser finalizada, pois foi cancelada",
                    "info"
                );
            } else if (props.row.reserve_status == "5") {
                swal(
                    "Erro",
                    "Esta reserva não pode ser finalizada, pois foi finalizada",
                    "info"
                );
            } else {
                // Armazenar dados da reserva atual e abrir modal
                this.currentReserveToFinish = props.row;
                this.finishForm.km_inicial = props.row.vehicles.current_km || 0;
                this.finishForm.km_final = null;
                this.showFinishModal = true;
            }
        },

        closeFinishModal() {
            this.showFinishModal = false;
            this.currentReserveToFinish = null;
            this.finishForm = {
                km_inicial: 0,
                km_final: null
            };
        },

        confirmFinish() {
            if (!this.finishForm.km_final || this.finishForm.km_final < this.finishForm.km_inicial) {
                this.$message(null, "KM final deve ser maior ou igual ao KM inicial", "error");
                return;
            }

            const self = this;
            const kmTraveled = this.finishForm.km_final - this.finishForm.km_inicial;

            let api = self.$store.state.api + "reserveVehicles/finish";
            let fd = new FormData();

            fd.append("km_inicial", this.finishForm.km_inicial);
            fd.append("km_final", this.finishForm.km_final);
            fd.append("km_traveled", kmTraveled);
            fd.append("reserve_id", this.currentReserveToFinish.id);

            self.$http.post(api, fd).then((response) => {
                swal("Sucesso", "Reserva finalizada com sucesso!", "success");
                this.currentReserveToFinish.reserve_statuses.title = "Devolvido";
                this.closeFinishModal();
                // Atualiza a tabela preservando os filtros
                this.forceTableRerender();
            }).catch((error) => {
                const message = error.response.data.errors ? getMessage(error.response.data.errors) : error.response.data
                self.$message(null, message, "error");
            });
        },

        save(props) {
            const self = this;

            let api = self.$store.state.api + "reserveVehicles/" + props.row.id;
            let fd = new FormData();

            fd.append("_method", "PATCH");
            fd.append("agent", "WEB");
            fd.append("observation", "Cancelado via Portal Admin");
            fd.append("reserve_status", "3");

            swal({
                title: "Deseja cancelar a reserva?",
                text: "Essa operação não pode ser desfeita",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Sim, cancelar!",
                showLoaderOnConfirm: true,
                buttons: {
                    catch: {
                        text: "Não",
                        value: "cancel",
                        className: "btn-danger",
                    },
                    confirm: {
                        text: "Sim",
                        value: "confirm",
                    },
                },
            })
                .then((value) => {
                    switch (value) {
                        case "cancel":
                            swal("Cancelado", "A reserva não foi cancelada!", "info");
                            break;

                        case "confirm":
                            self.$http.post(api, fd).then((response) => {
                                props.row.vehicle_status_id = status;
                                swal("Sucesso", "Reserva cancelada com sucesso!", "success");
                                props.row.reserve_statuses.title = "Cancelado";
                                // Atualiza a tabela preservando os filtros
                                self.forceTableRerender();
                            });
                            break;
                    }
                })
                .catch((error) => {
                    const message = error.response.data.errors ? getMessage(error.response.data.errors) : error.response.data
                    self.$message(null, message, "error");
                });
        },

        // Método para inicializar templates e botões de forma consistente
        initializeTemplatesAndButtons() {
            const user = this.$store.state.user;

            // Verifica se o usuário está carregado
            if (!user || !user.hasOwnProperty('access_nivel')) {
                console.warn('Usuário ainda não carregado, tentando novamente em 100ms...');
                setTimeout(() => {
                    this.initializeTemplatesAndButtons();
                }, 100);
                return;
            }

            console.log('Inicializando templates com usuário:', user);

            // Template para descrição do veículo / Template for vehicle description
            this.options.templates.vehicle_id = createVehicleTemplate(
                user,
                'description',
                'Veículo Oculto',
                'Veículo oculto - será revelado próximo à retirada',
                this.currentTime
            );

            // Template para placa do veículo / Template for vehicle board
            this.options.templates.vehicle_board = createVehicleTemplate(
                user,
                'board',
                '***-***',
                'Placa oculta - será revelada próximo à retirada',
                this.currentTime
            );

            // Limpa botões extras antes de adicionar novos
            this.extra = [
                {
                    id: 2,
                    label: "",
                    class: "btn btn-crud cancel fas fa-ban mr-2",
                    title: "Cancelar Reserva",
                    name: "cancel",
                    icon: "fas fa-ban",
                }
            ];

            // Adiciona botões de editar e finalizar apenas para usuários com access_nivel > 2
            if (user && user.access_nivel > 2) {
                this.extra.unshift({
                    id: 1,
                    label: "",
                    class: "fas fa-pencil-alt btn btn-crud edit2 mr-2",
                    title: "Editar",
                    name: "editing",
                    icon: "btn btn-crud edit2",
                });

                this.extra.push({
                    id: 3,
                    label: "",
                    class: "btn btn-outline-success finish fas fa-check-circle text-success",
                    title: "Finalizar Reserva",
                    name: "finish",
                    icon: "fas fa-check-circle",
                });
            }

            console.log('Templates e botões inicializados. Botões extras:', this.extra.length);
        },

        // Método para atualizar templates com novo tempo
        updateTemplatesWithCurrentTime() {
            const user = this.$store.state.user;

            // Verifica se o usuário ainda está disponível
            if (!user || !user.hasOwnProperty('access_nivel')) {
                console.warn('Usuário não disponível para atualização de templates');
                return;
            }

            // Atualiza os templates com o tempo atual
            this.options.templates.vehicle_id = createVehicleTemplate(
                user,
                'description',
                'Veículo Oculto',
                'Veículo oculto - será revelado próximo à retirada',
                this.currentTime
            );

            this.options.templates.vehicle_board = createVehicleTemplate(
                user,
                'board',
                '***-***',
                'Placa oculta - será revelada próximo à retirada',
                this.currentTime
            );

            // Força a re-renderização da tabela
            this.forceTableRerender();
        },

        // Método para forçar re-renderização da tabela
        forceTableRerender() {
            // Usa o método refresh() da tabela que preserva os filtros e paginação
            if (this.$refs.baseCrud && this.$refs.baseCrud.$refs.table) {
                const table = this.$refs.baseCrud.$refs.table;
                const currentPage = table.page;

                // Usa getData() passando a página atual para evitar chamada duplicada
                if (table.getData) {
                    table.getData(currentPage);
                } else {
                    table.refresh();
                }
            }
        },

        // Inicia o interval para atualizar o tempo a cada minuto
        startTimeUpdateInterval() {
            // Atualiza a cada 60 segundos (60000ms)
            this.timeUpdateInterval = setInterval(() => {
                this.currentTime = new Date();
                // Note: updateTemplatesWithCurrentTime() será chamado automaticamente pelo watcher
            }, 60000);
        },

        // Método público para forçar atualização manual (pode ser chamado via console)
        refreshVisibility() {
            this.currentTime = new Date();
            this.updateTemplatesWithCurrentTime();
            console.log('Visibilidade atualizada manualmente');
        },

        // Método para carregar centros de custos
        loadCostCenters() {
            const api = this.$store.state.api + 'cost-centers';
            this.$http.get(api, { params: { paginated: false, orderByAsc: 'erp_code' } })
                .then((response) => {
                    const costCenters = response.data.data || [];

                    // Adiciona opção "Compartilhado" para veículos sem centro de custos
                    this.options.listColumns.cost_center_id = [
                        { id: '-1', text: 'Veículo de Locação' },
                        ...costCenters.map(cc => ({
                            id: cc.id,
                            text: cc.erp_code
                        }))
                    ];
                })
                .catch((error) => {
                    console.error('Erro ao carregar centros de custos:', error);
                });
        },
    },
    mounted: function () {
        localStorage.setItem('agent', 'web');

        // Aguarda o store estar carregado antes de inicializar
        this.$nextTick(() => {
            // Aguarda mais um tick para garantir que o Vuex está carregado
            this.$nextTick(() => {
                this.initializeTemplatesAndButtons();
                this.startTimeUpdateInterval();
                this.loadCostCenters();
            });
        });

        // Disponibiliza métodos de debug no console (apenas em desenvolvimento)
        if (process.env.NODE_ENV === 'development') {
            window.reserveDebug = {
                refreshVisibility: this.refreshVisibility,
                forceRerender: this.forceTableRerender,
                getCurrentTime: () => this.currentTime,
                getUserInfo: () => this.$store.state.user,
                reinitialize: () => this.initializeTemplatesAndButtons()
            };
            console.log('Debug tools available: window.reserveDebug');
        }
    },

    beforeDestroy() {
        // Limpa o interval quando o componente é destruído
        if (this.timeUpdateInterval) {
            clearInterval(this.timeUpdateInterval);
        }
    },
    computed: {
        // Computed property para forçar reatividade baseada no tempo
        timeBasedReactivity() {
            return {
                currentTime: this.currentTime,
                user: this.$store.state.user
            };
        }
    },

    watch: {
        // Watcher para reagir a mudanças de tempo e usuário
        timeBasedReactivity: {
            handler(newVal, oldVal) {
                if (oldVal && (newVal.currentTime !== oldVal.currentTime || newVal.user !== oldVal.user)) {
                    // Só atualiza se realmente houve mudança significativa (mais de 30 segundos)
                    const timeDiff = Math.abs(newVal.currentTime - oldVal.currentTime);
                    if (timeDiff > 30000) { // 30 segundos
                        this.updateTemplatesWithCurrentTime();
                    }
                }
            },
            deep: true
        },

        // Watcher específico para o usuário do store
        '$store.state.user': {
            handler(newUser, oldUser) {
                if (newUser && newUser.hasOwnProperty('access_nivel') && (!oldUser || !oldUser.hasOwnProperty('access_nivel'))) {
                    console.log('Usuário carregado no store, reinicializando componente...');
                    this.initializeTemplatesAndButtons();
                }
            },
            deep: true,
            immediate: true
        }
    },
};
</script>

<style>
.VuePagination {
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/ReserveVehicles/Crud.vue